window.BAO.MadeToOrder = {
  attach: (element) => {
    /**
     * @type {MadeToOrder}
     */
    element.madeToOrder = element.closest(`made-to-order`)
    const itemKeyElement = element.closest('[data-made-to-order-item-key]')
    if (!itemKeyElement) {
      return element.throwError(
        `Unable to find [data-made-to-order-item-key] element`,
      )
    }
    /**
     * @type {ProductGroup}
     */
    element.productGroup = element.madeToOrder.productGroups.find(
      (productGroup) => {
        return (
          productGroup.key ===
          itemKeyElement.getAttribute('data-made-to-order-item-key')
        )
      },
    )
    /**
     * @type {ProductGroup|undefined}
     */
    element.dependentProductGroup = element.madeToOrder.productGroups.find(
      (productGroup) => {
        return (
          productGroup.key ===
          element.productGroup.configurationProductGroup.dependentProductGroupId
        )
      },
    )
    /**
     * @type {SiteDrawer}
     */
    element.drawer = window.BAO.Utils.getElement('dialog[is="site-drawer"]', {
      context: element.madeToOrder,
    })
  },
}
